"use strict";
exports.add = add;
var _index = require("./addDays.js");
var _index2 = require("./addMonths.js");
var _index3 = require("./constructFrom.js");
var _index4 = require("./toDate.js");
function add(date, duration) {
  const {
    years = 0,
    months = 0,
    weeks = 0,
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0
  } = duration;
  const _date = (0, _index4.toDate)(date);
  const dateWithMonths = months || years ? (0, _index2.addMonths)(_date, months + years * 12) : _date;
  const dateWithDays = days || weeks ? (0, _index.addDays)(dateWithMonths, days + weeks * 7) : dateWithMonths;
  const minutesToAdd = minutes + hours * 60;
  const secondsToAdd = seconds + minutesToAdd * 60;
  const msToAdd = secondsToAdd * 1e3;
  const finalDate = (0, _index3.constructFrom)(
    date,
    dateWithDays.getTime() + msToAdd
  );
  return finalDate;
}
